var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "announcements alert", attrs: { id: "announcements" } },
    [
      _c(
        "button",
        {
          staticClass: "show-more-tab",
          attrs: { type: "button" },
          on: { click: _vm.showMore }
        },
        [
          _c(
            "span",
            [
              _vm.isActive
                ? _c("font-awesome-icon", { attrs: { icon: "angle-up" } })
                : _c("font-awesome-icon", { attrs: { icon: "angle-down" } })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [
            _vm.isActive
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Announcements.labelLess")))
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Announcements.labelMore")))
                ]),
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$t("MAIN_CONTENT.Announcements.labelAnnouncements")
                ) +
                "\n\t\t"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "panel sapphire-panel-info" }, [
        _c("div", { staticClass: "panel-heading" }, [
          _vm.showDismiss
            ? _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-target": "#sannouncements",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h2", { staticClass: "panel-title" }, [_vm._v(_vm._s(_vm.title))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "panel-body",
            class: { "restrict-height": !_vm.isActive }
          },
          _vm._l(_vm.announcements, function(item, index) {
            return _c("span", { key: item.ANNOUNCEMENT_RID }, [
              !!item.SCHOOL_TITLE
                ? _c("h4", [_c("strong", [_vm._v(_vm._s(item.SCHOOL_TITLE))])])
                : _c("h4", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.Announcements.labelDistrictWideAnnouncement"
                          )
                        )
                      )
                    ])
                  ]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(item.ANNOUNCEMENT) } }),
              _vm._v(" "),
              index < _vm.announcements.length - 1 ? _c("hr") : _vm._e()
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "show-more",
            attrs: { type: "button" },
            on: { click: _vm.showMore }
          },
          [
            _vm.isActive
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Announcements.labelLess")))
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Announcements.labelMore")))
                ]),
            _vm._v(
              " \n\t\t\t" +
                _vm._s(
                  _vm.$t("MAIN_CONTENT.Announcements.labelAnnouncements")
                ) +
                "\n\t\t"
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }